export default __webpack_public_path__ + "static/media/logo5.adab4e4e.png";